import React from 'react';
import FusionCheckbox from '@acuity-brands/fusion/components/Checkbox';
import {FusionPropTypes} from '../prop-types';

/**
 * @note Only for use inside the Form component. If you need to use
 * the Fusion Checkbox component, use it directly.
 */
export const FusionCheckboxAdapter = ({
  data,
  disabled,
  field,
  handleChange,
  name,
}) => {
  /**
   * @note This is only necessary because:
   * - we submit the form as a FormData object,
   *     which stringifies all the data
   * - when we update the form due to related
   *     form fields changing, we don't attempt
   *     to clean the data on the backend
   * - it serialized back to us as strings.
   *
   * We should probably either always clean,
   * or not use FormData. Ticketed here:
   * https://ablcode.visualstudio.com/Lucid/_workitems/edit/1050693
   */
  const dataAsBool = data === 'true' || data === true;

  return (
    <FusionCheckbox
      checked={dataAsBool}
      disabled={disabled}
      label={field.widget.attrs.hideLabel ? '' : field.label}
      name={name}
      onChange={() => {
        handleChange(!data);
      }}
      required={field.required && !field.widget.attrs.hideLabel}
      tooltip={field.help_text}
    />
  );
};

FusionCheckboxAdapter.propTypes = FusionPropTypes;
